/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProgressRing from './ProgressRing.vue';
const __vue_script__ = {
	name: 'FilePreview',
	props: ['file'],
	components: {
		ProgressRing
	},
	data() {
		return {
			src: null,
			optimize: this.file.optimize
		}
	},
	mounted() {
		if (this.is_image) {
			if (window.FileReader) {
				let fr = new FileReader();
				fr.onload = () => this.src = fr.result;
				fr.readAsDataURL(this.file.file_obj);
			}
		}
	},
	filters: {
		file_size(value) {
			return ducky.form.formatters.FileSize(value);
		},
		file_name(value) {
			return value;
			// return ducky.utils.file_name_ellipsis(value, 9);
		}
	},
	computed: {
		is_private() {
			return this.file.doc ? this.file.doc.is_private : this.file.private;
		},
		uploaded() {
			return this.file.request_succeeded;
		},
		is_image() {
			return this.file.file_obj.type.startsWith('image');
		},
		is_optimizable() {
			let is_svg = this.file.file_obj.type == 'image/svg+xml';
			return this.is_image && !is_svg && !this.uploaded && !this.file.failed;
		},
		is_cropable() {
			let croppable_types = ['image/jpeg', 'image/png'];
			return !this.uploaded && !this.file.uploading && !this.file.failed && croppable_types.includes(this.file.file_obj.type);
		},
		progress() {
			let value = Math.round((this.file.progress * 100) / this.file.total);
			if (isNaN(value)) {
				value = 0;
			}
			return value;
		}
	}
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-preview" }, [
    _c("div", { staticClass: "file-icon" }, [
      _vm.is_image
        ? _c("img", { attrs: { src: _vm.src, alt: _vm.file.name } })
        : _c("div", {
            staticClass: "fallback",
            domProps: { innerHTML: _vm._s(_vm.ducky.utils.icon("file", "md")) }
          })
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", [
        _vm.file.doc
          ? _c(
              "a",
              {
                staticClass: "flex",
                attrs: { href: _vm.file.doc.file_url, target: "_blank" }
              },
              [
                _c("span", { staticClass: "file-name" }, [
                  _vm._v(_vm._s(_vm._f("file_name")(_vm.file.name)))
                ])
              ]
            )
          : _c("span", { staticClass: "file-name" }, [
              _vm._v(_vm._s(_vm._f("file_name")(_vm.file.name)))
            ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "file-size" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm._f("file_size")(_vm.file.file_obj.size)) +
              "\n\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex config-area" }, [
        _vm.is_optimizable
          ? _c("label", { staticClass: "ducky-checkbox" }, [
              _c("input", {
                attrs: { type: "checkbox" },
                domProps: { checked: _vm.optimize },
                on: {
                  change: function($event) {
                    return _vm.$emit("toggle_optimize")
                  }
                }
              }),
              _vm._v("Optimize")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("label", { staticClass: "ducky-checkbox" }, [
          _c("input", {
            attrs: { type: "checkbox" },
            domProps: { checked: _vm.file.private },
            on: {
              change: function($event) {
                return _vm.$emit("toggle_private")
              }
            }
          }),
          _vm._v("Private")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.file.error_message
          ? _c("span", { staticClass: "file-error text-danger" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.file.error_message) + "\n\t\t\t")
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "file-actions" },
      [
        _c("ProgressRing", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.file.uploading && !_vm.uploaded && !_vm.file.failed,
              expression: "file.uploading && !uploaded && !file.failed"
            }
          ],
          attrs: {
            primary: "var(--primary-color)",
            secondary: "var(--gray-200)",
            radius: 24,
            progress: _vm.progress,
            stroke: 3
          }
        }),
        _vm._v(" "),
        _vm.uploaded
          ? _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.ducky.utils.icon("solid-success", "lg"))
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.file.failed
          ? _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.ducky.utils.icon("solid-error", "lg"))
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "file-action-buttons" }, [
          _vm.is_cropable
            ? _c("button", {
                staticClass: "btn btn-crop muted",
                domProps: {
                  innerHTML: _vm._s(_vm.ducky.utils.icon("crop", "md"))
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("toggle_image_cropper")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.uploaded && !_vm.file.uploading && !_vm.file.failed
            ? _c("button", {
                staticClass: "btn muted",
                domProps: {
                  innerHTML: _vm._s(_vm.ducky.utils.icon("delete", "md"))
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("remove")
                  }
                }
              })
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-11f6567d_0", { source: "\n.file-preview {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0.75rem;\n\tborder: 1px solid transparent;\n}\n.file-preview + .file-preview {\n\tborder-top-color: var(--border-color);\n}\n.file-preview:hover {\n\tbackground-color: var(--bg-color);\n\tborder-color: var(--dark-border-color);\n\tborder-radius: var(--border-radius);\n}\n.file-preview:hover + .file-preview {\n\tborder-top-color: transparent;\n}\n.file-icon {\n\tborder-radius: var(--border-radius);\n\twidth: 2.625rem;\n\theight: 2.625rem;\n\toverflow: hidden;\n\tmargin-right: var(--margin-md);\n\tflex-shrink: 0;\n}\n.file-icon img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n.file-icon .fallback {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid var(--border-color);\n\tborder-radius: var(--border-radius);\n}\n.file-name {\n\tfont-size: var(--text-base);\n\tfont-weight: var(--text-bold);\n\tcolor: var(--text-color);\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 1;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n}\n.file-size {\n\tfont-size: var(--text-sm);\n\tcolor: var(--text-light);\n}\n.file-actions {\n\twidth: 3rem;\n\tflex-shrink: 0;\n\tmargin-left: auto;\n\ttext-align: center;\n}\n.file-actions .btn {\n\tpadding: var(--padding-xs);\n\tbox-shadow: none;\n}\n.file-action-buttons {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n.muted {\n\topacity: 0.5;\n\ttransition: 0.3s;\n}\n.muted:hover {\n\topacity: 1;\n}\n.ducky-checkbox {\n\tfont-size: var(--text-sm);\n\tcolor: var(--text-light);\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-top: 0.25rem;\n}\n.config-area {\n\tgap: 0.5rem;\n}\n.file-error {\n\tfont-size: var(--text-sm);\n\tfont-weight: var(--text-bold);\n}\n", map: {"version":3,"sources":["ducky/public/js/ducky/file_uploader/FilePreview.vue"],"names":[],"mappings":";AAoHA;CACA,aAAA;CACA,mBAAA;CACA,gBAAA;CACA,6BAAA;AACA;AAEA;CACA,qCAAA;AACA;AAEA;CACA,iCAAA;CACA,sCAAA;CACA,mCAAA;AACA;AAEA;CACA,6BAAA;AACA;AAEA;CACA,mCAAA;CACA,eAAA;CACA,gBAAA;CACA,gBAAA;CACA,8BAAA;CACA,cAAA;AACA;AAEA;CACA,WAAA;CACA,YAAA;CACA,iBAAA;AACA;AAEA;CACA,WAAA;CACA,YAAA;CACA,aAAA;CACA,mBAAA;CACA,uBAAA;CACA,qCAAA;CACA,mCAAA;AACA;AAEA;CACA,2BAAA;CACA,6BAAA;CACA,wBAAA;CACA,oBAAA;CACA,qBAAA;CACA,4BAAA;CACA,gBAAA;AACA;AAEA;CACA,yBAAA;CACA,wBAAA;AACA;AAEA;CACA,WAAA;CACA,cAAA;CACA,iBAAA;CACA,kBAAA;AACA;AAEA;CACA,0BAAA;CACA,gBAAA;AACA;AAEA;CACA,aAAA;CACA,yBAAA;AACA;AAEA;CACA,YAAA;CACA,gBAAA;AACA;AAEA;CACA,UAAA;AACA;AAEA;CACA,yBAAA;CACA,wBAAA;CACA,aAAA;CACA,mBAAA;CACA,oBAAA;AACA;AAEA;CACA,WAAA;AACA;AAEA;CACA,yBAAA;CACA,6BAAA;AACA","file":"FilePreview.vue","sourcesContent":["<template>\n\t<div class=\"file-preview\">\n\t\t<div class=\"file-icon\">\n\t\t\t<img\n\t\t\t\tv-if=\"is_image\"\n\t\t\t\t:src=\"src\"\n\t\t\t\t:alt=\"file.name\"\n\t\t\t>\n\t\t\t<div class=\"fallback\" v-else v-html=\"ducky.utils.icon('file', 'md')\">\n\t\t\t</div>\n\t\t</div>\n\t\t<div>\n\t\t\t<div>\n\t\t\t\t<a class=\"flex\" :href=\"file.doc.file_url\" v-if=\"file.doc\" target=\"_blank\">\n\t\t\t\t\t<span class=\"file-name\">{{ file.name | file_name }}</span>\n\t\t\t\t</a>\n\t\t\t\t<span class=\"file-name\" v-else>{{ file.name | file_name }}</span>\n\t\t\t</div>\n\n\t\t\t<div>\n\t\t\t\t<span class=\"file-size\">\n\t\t\t\t\t{{ file.file_obj.size | file_size }}\n\t\t\t\t</span>\n\t\t\t</div>\n\n\t\t\t<div class=\"flex config-area\">\n\t\t\t\t<label v-if=\"is_optimizable\" class=\"ducky-checkbox\"><input type=\"checkbox\" :checked=\"optimize\" @change=\"$emit('toggle_optimize')\">Optimize</label>\n\t\t\t\t<label class=\"ducky-checkbox\"><input type=\"checkbox\" :checked=\"file.private\" @change=\"$emit('toggle_private')\">Private</label>\n\t\t\t</div>\n\t\t\t<div>\n\t\t\t\t<span v-if=\"file.error_message\" class=\"file-error text-danger\">\n\t\t\t\t\t{{ file.error_message }}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"file-actions\">\n\t\t\t<ProgressRing\n\t\t\t\tv-show=\"file.uploading && !uploaded && !file.failed\"\n\t\t\t\tprimary=\"var(--primary-color)\"\n\t\t\t\tsecondary=\"var(--gray-200)\"\n\t\t\t\t:radius=\"24\"\n\t\t\t\t:progress=\"progress\"\n\t\t\t\t:stroke=\"3\"\n\t\t\t/>\n\t\t\t<div v-if=\"uploaded\" v-html=\"ducky.utils.icon('solid-success', 'lg')\"></div>\n\t\t\t<div v-if=\"file.failed\" v-html=\"ducky.utils.icon('solid-error', 'lg')\"></div>\n\t\t\t<div class=\"file-action-buttons\">\n\t\t\t\t<button v-if=\"is_cropable\" class=\"btn btn-crop muted\" @click=\"$emit('toggle_image_cropper')\" v-html=\"ducky.utils.icon('crop', 'md')\"></button>\n\t\t\t\t<button v-if=\"!uploaded && !file.uploading && !file.failed\" class=\"btn muted\" @click=\"$emit('remove')\" v-html=\"ducky.utils.icon('delete', 'md')\"></button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\nimport ProgressRing from './ProgressRing.vue';\nexport default {\n\tname: 'FilePreview',\n\tprops: ['file'],\n\tcomponents: {\n\t\tProgressRing\n\t},\n\tdata() {\n\t\treturn {\n\t\t\tsrc: null,\n\t\t\toptimize: this.file.optimize\n\t\t}\n\t},\n\tmounted() {\n\t\tif (this.is_image) {\n\t\t\tif (window.FileReader) {\n\t\t\t\tlet fr = new FileReader();\n\t\t\t\tfr.onload = () => this.src = fr.result;\n\t\t\t\tfr.readAsDataURL(this.file.file_obj);\n\t\t\t}\n\t\t}\n\t},\n\tfilters: {\n\t\tfile_size(value) {\n\t\t\treturn ducky.form.formatters.FileSize(value);\n\t\t},\n\t\tfile_name(value) {\n\t\t\treturn value;\n\t\t\t// return ducky.utils.file_name_ellipsis(value, 9);\n\t\t}\n\t},\n\tcomputed: {\n\t\tis_private() {\n\t\t\treturn this.file.doc ? this.file.doc.is_private : this.file.private;\n\t\t},\n\t\tuploaded() {\n\t\t\treturn this.file.request_succeeded;\n\t\t},\n\t\tis_image() {\n\t\t\treturn this.file.file_obj.type.startsWith('image');\n\t\t},\n\t\tis_optimizable() {\n\t\t\tlet is_svg = this.file.file_obj.type == 'image/svg+xml';\n\t\t\treturn this.is_image && !is_svg && !this.uploaded && !this.file.failed;\n\t\t},\n\t\tis_cropable() {\n\t\t\tlet croppable_types = ['image/jpeg', 'image/png'];\n\t\t\treturn !this.uploaded && !this.file.uploading && !this.file.failed && croppable_types.includes(this.file.file_obj.type);\n\t\t},\n\t\tprogress() {\n\t\t\tlet value = Math.round((this.file.progress * 100) / this.file.total);\n\t\t\tif (isNaN(value)) {\n\t\t\t\tvalue = 0;\n\t\t\t}\n\t\t\treturn value;\n\t\t}\n\t}\n}\n</script>\n\n<style>\n.file-preview {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0.75rem;\n\tborder: 1px solid transparent;\n}\n\n.file-preview + .file-preview {\n\tborder-top-color: var(--border-color);\n}\n\n.file-preview:hover {\n\tbackground-color: var(--bg-color);\n\tborder-color: var(--dark-border-color);\n\tborder-radius: var(--border-radius);\n}\n\n.file-preview:hover + .file-preview {\n\tborder-top-color: transparent;\n}\n\n.file-icon {\n\tborder-radius: var(--border-radius);\n\twidth: 2.625rem;\n\theight: 2.625rem;\n\toverflow: hidden;\n\tmargin-right: var(--margin-md);\n\tflex-shrink: 0;\n}\n\n.file-icon img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.file-icon .fallback {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid var(--border-color);\n\tborder-radius: var(--border-radius);\n}\n\n.file-name {\n\tfont-size: var(--text-base);\n\tfont-weight: var(--text-bold);\n\tcolor: var(--text-color);\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 1;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n}\n\n.file-size {\n\tfont-size: var(--text-sm);\n\tcolor: var(--text-light);\n}\n\n.file-actions {\n\twidth: 3rem;\n\tflex-shrink: 0;\n\tmargin-left: auto;\n\ttext-align: center;\n}\n\n.file-actions .btn {\n\tpadding: var(--padding-xs);\n\tbox-shadow: none;\n}\n\n.file-action-buttons {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.muted {\n\topacity: 0.5;\n\ttransition: 0.3s;\n}\n\n.muted:hover {\n\topacity: 1;\n}\n\n.ducky-checkbox {\n\tfont-size: var(--text-sm);\n\tcolor: var(--text-light);\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-top: 0.25rem;\n}\n\n.config-area {\n\tgap: 0.5rem;\n}\n\n.file-error {\n\tfont-size: var(--text-sm);\n\tfont-weight: var(--text-bold);\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ducky/public/js/ducky/file_uploader/FilePreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__